export default __webpack_public_path__ + "static/media/debian.fc34ae29.svg";